import StatusMessageController from './status-message-controller';

export default function (app) {
	app.directive('statusMessage', function () {
		return {
			restrict: 'A',
			scope: {
				statusMessages: '=',
				object: '=',
				index: '='
			},
			link: function (scope, element) {
				// így mindig egymás alatt jelennek meg a popupok, az elso popup css-ét ne módósítja
				// TODO: (nice to have) ha egy felső bezáródik, akkor az alatta lévők csússzanak fentebb

				var statusMessageElements = element.find('.status-message');

				if(statusMessageElements.length > 1){
					for(let i=1;i<statusMessageElements.length;i++ ){
						statusMessageElements[i].css('top', 40 + scope.index * 110)
					};
				}
			},
			controller: ['$scope', '$state', '$timeout', StatusMessageController],
			templateUrl: 'status-message'
		};
	});
}
